import { render, staticRenderFns } from "./CookiePolicy.vue?vue&type=template&id=c81674a2"
import script from "./CookiePolicy.vue?vue&type=script&lang=js"
export * from "./CookiePolicy.vue?vue&type=script&lang=js"
import style0 from "./CookiePolicy.vue?vue&type=style&index=0&id=c81674a2&prod&lang=css"
import style1 from "./CookiePolicy.vue?vue&type=style&index=1&id=c81674a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports